import React from "react";

export default function CompleteActionsModal({
    open,
    onClose,
    onPrintShipping,
    onPrintInvoice,
    onConfirmPackSeal,
}) {
    if (!open) return null;

    return (
        <>
            <div className="modal d-block show" tabIndex="-1" role="dialog" aria-modal="true">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">

                        <div className="modal-header">
                            <h6 className="modal-title">Packing Actions</h6>
                            <button type="button" className="btn-close" aria-label="Close" onClick={onClose} />
                        </div>

                        <div className="modal-body">
                            <div className="d-flex flex-column align-items-center gap-3">

                                <button
                                    type="button"
                                    className="btn btn-outline-primary"
                                    onClick={onPrintShipping}
                                >
                                    Print Shipping Label
                                </button>

                                <button
                                    type="button"
                                    className="btn btn-outline-primary"
                                    onClick={onPrintInvoice}
                                >
                                    Print Invoice Label
                                </button>

                                <button
                                    type="button"
                                    className="btn btn-success"
                                    onClick={onConfirmPackSeal}
                                >
                                    Confirm Pack &amp; Seal
                                </button>

                                <button
                                    type="button"
                                    className="btn btn-outline-secondary"
                                    onClick={onClose}
                                >
                                    Back
                                </button>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
            {/* Backdrop */}
            <div className="modal-backdrop fade show"></div>
        </>
    );
}
